<template>
  <div>
    <v-list two-line subheader>
      <v-list-item class="mb-2">
        <v-list-item-content>
          <h2 class="mt-2 mb-4">{{ doc.title }}</h2>
          <p>{{ doc.description }}</p>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Show results</v-list-item-title>
          <v-list-item-subtitle>{{ doc.showResults }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Users</v-list-item-title>
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">First name</th>
                      <th class="text-left">Last name</th>
                      <th class="text-left">Company</th>
                      <th class="text-left">Role</th>
                      <th class="text-left">Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in doc.users" :key="item.name">
                      <td>{{ item.first }}</td>
                      <td>{{ item.last }}</td>
                      <td>{{ item.company }}</td>
                      <td>{{ item.webrole }}</td>
                      <td>{{ item.email }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Exercises</v-list-item-title>
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Title</th>
                      <th class="text-left">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in doc.exercisesOrder" :key="item.title">
                      <td>{{ item.title }}</td>
                      <td>{{ item.description }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Benchmarks</v-list-item-title>
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Title</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in doc.benchmarksOrder" :key="item.title">
                      <td>{{ item.title }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Planes</v-list-item-title>
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Title</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in doc.planesOrder" :key="item.title">
                      <td>{{ item.title }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Functionality</v-list-item-title>
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Title</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in doc.functionalityOrder"
                      :key="item.title"
                    >
                      <td>{{ item.title }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AdminGroupShow",
  data() {
    return {
      doc: {},
    };
  },
  created() {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
};
</script>

<style lang="scss">
.tiles {
  display: flex;
  margin-top: 1rem;
  flex-wrap: wrap;
  .tile {
    width: 150px;
    height: 150px;
    background-size: cover;
    margin: 2px;
  }
}
</style>
